import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { FirebaseDocRefType } from 'firebase/index'
import { StockType } from 'types/stock'
import { hideLoading, showLoading } from 'reducks/loading/operations'
import { dateToString } from 'lib/helper'
import { fetchFutureStocks } from 'reducks/stock/operations'
import { updateModalHeader } from 'reducks/modal/operations'
import { BreadType } from 'types/bread'
import { StoreDeliveryBreadType } from 'types/storeDeliveryBread'
import { sendNewStoreMessage } from 'reducks/messages/operations'
import { State } from 'index'
import { getIsBeforePublishingStock, getStoreStatus } from 'reducks/store/selectors'
import { updatePublishFirstStock } from 'reducks/store/operations'
import { publishFirstStock } from 'repos/store'
import { addNotifiedTypes } from 'reducks/bread/operations'
import { addStoreStockMessageQueue } from 'reducks/storeStockMessageQueue/operations'

const useSaveIndividualDeliveryStock = (
  backToSelectDate: () => void,
  bread: BreadType,
  settingDate: Date | undefined,
  storeDeliveryBread: StoreDeliveryBreadType,
  storeRef: FirebaseDocRefType
): ((individualStock: StockType) => Promise<void>) => {
  const dispatch = useDispatch()
  const storeStatus = useSelector((state: State) => getStoreStatus(state))
  const isBeforePublishingStock = useSelector((state: State) => getIsBeforePublishingStock(state))
  return useCallback(
    async (individualStock: StockType) => {
      if (!bread.bread_ref) return
      if (!settingDate) return
      const stockId = `stock_delivery_${storeDeliveryBread.ref?.id}-${dateToString(settingDate)}_00:00`
      // 新規作成
      if (typeof individualStock.stock_ref === 'undefined') {
        individualStock.stock_ref = storeRef.collection('store_stocks').doc(stockId)
      }
      const ref = individualStock.stock_ref
      delete individualStock.stock_ref
      try {
        dispatch(showLoading())
        // 店舗が初めて在庫を公開する場合、5km圏内のユーザーにPush通知を送る
        if (isBeforePublishingStock && storeStatus === 'public') {
          await publishFirstStock(storeRef)
          await dispatch(updatePublishFirstStock())
          await sendNewStoreMessage(storeRef)
        } else {
          // この商品で初めて在庫を設定する場合、ユーザーに通知を送る
          const type = 'delivery'
          if (!bread.notified_types?.includes(type)) {
            await Promise.all([
              addNotifiedTypes({ bread, type }),
              addStoreStockMessageQueue({ breadRef: bread.bread_ref, storeRef }),
            ])
          }
        }
        await ref.set(individualStock, { merge: true })
        backToSelectDate()
        dispatch(fetchFutureStocks({ storeRef, types: ['delivery'] }))
        dispatch(hideLoading())
        dispatch(updateModalHeader('個別日の設定を行う', '設定を変更したい日を選択してください。'))
      } catch (e) {
        console.error(e)
        dispatch(hideLoading())
      }
    },
    [backToSelectDate, bread, settingDate, storeDeliveryBread, storeRef]
  )
}

export default useSaveIndividualDeliveryStock
